<script setup>

import { inject, ref, computed } from 'vue';
import { 
	apiAjouterElementRapport } from '@/services/ServiceModele.js';
import TieredMenu from 'primevue/tieredmenu';

const { section, selectionnee } = defineProps({
	section: Object,
    selectionnee: Boolean
});

const selectionnerSection = inject('selectionnerSection');
const appelerApiModifModele = inject('appelerApiModifModele');

const menu = ref(null);
const affichageMenu = ref(false);

const itemsMenu = computed(() => {
    return getItemsMenu(section);
});

function getItemsMenu(section) {
    const items = section.sousSections.map(sousSection => {
        return {
            label: sousSection.nom,
            command: () => selectionnerSection(sousSection.positionSection),
            items: getItemsMenu(sousSection)
        };
    });
    if (section.sousSections.length > 0) {
        items.push({separator: true});
        items.push({
            label: 'Nouvelle section...',
            icon: 'fa fa-plus',
            command: () => ajouterSousSection(section)
        });
    }
    return items;
}

function afficherMenu(event) {
    affichageMenu.value = true;
    menu.value.toggle(event);
}

function ajouterSousSection(section) {
    const indiceNouvelleSection = section.sousSections.length;
	appelerApiModifModele(apiAjouterElementRapport, section.positionSection, [indiceNouvelleSection], 'SECTION', (reponseOK) => {
		if (reponseOK) {
            const positionNouvelleSection = section.positionSection.slice();
            positionNouvelleSection.push(indiceNouvelleSection);
			selectionnerSection(positionNouvelleSection, true);
		}
	});
}

</script>

<template>
    <div class="element-fil-ariane">
        <button
            class="lien-interne nom-section" 
            @click="selectionnerSection(section.positionSection)">
            {{ section.positionSection.length > 0 ? section.nom : 'Page principale' }}
        </button>
        <i 
            v-if="section.sousSections.length > 0"
            class="fa fa-caret-right fleche-navigation" 
            @click="afficherMenu" />
        <i 
            v-else
            class="fa fa-plus fleche-navigation" 
            v-tooltip="'Créer une sous-section'"
            @click="ajouterSousSection(section)" />
    </div>
    <TieredMenu ref="menu" :model="itemsMenu" popup />
</template>

<style scoped>

.element-fil {
    display: flex;
    flex-direction: row;
    gap: 5px;
    padding: 2px 5px;
    align-items: center;
}

.nom-section {
    white-space: nowrap;
    text-overflow: ellipsis;
    color: var(--couleur-primaire);
    font-size: 10px;
}

.fleche-navigation {
    color: var(--couleur-primaire);
    padding: 3px 7px 3px 5px;
    margin: 0px 1px;
    cursor: pointer;
    border: 1px solid transparent;
    border-radius: 3px;
}

.fleche-navigation:hover {
    border-color: var(--couleur-primaire);
}

</style>